export default "__VITE_ASSET__2ec00f67__"